var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.28125C5.68782 0.28125 4.21875 1.75032 4.21875 3.5625C4.21875 5.37468 5.68782 6.84375 7.5 6.84375C9.31218 6.84375 10.7812 5.37468 10.7812 3.5625C10.7812 1.75032 9.31218 0.28125 7.5 0.28125Z",
    fill: "#D23331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.59375C2.18782 8.59375 0.71875 10.0628 0.71875 11.875V12.9147C0.71875 13.5738 1.1964 14.1358 1.84686 14.242C5.59084 14.8532 9.40916 14.8532 13.1531 14.242C13.8036 14.1358 14.2812 13.5738 14.2812 12.9147V11.875C14.2812 10.0628 12.8122 8.59375 11 8.59375H10.7017C10.5403 8.59375 10.3799 8.61928 10.2264 8.66938L9.46911 8.91668C8.18961 9.33447 6.81039 9.33447 5.53089 8.91668L4.77356 8.66938C4.62011 8.61928 4.45969 8.59375 4.29826 8.59375H4Z",
    fill: "#D23331"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPerson);
export default __webpack_public_path__ + "static/media/ico-person.fb86ad20f8163e798fb9a633adbc8f29.svg";
export { ForwardRef as ReactComponent };